import { render, staticRenderFns } from "./TcEdit.vue?vue&type=template&id=074e7c20&scoped=true"
import script from "./TcEdit.vue?vue&type=script&lang=ts"
export * from "./TcEdit.vue?vue&type=script&lang=ts"
import style0 from "./TcEdit.vue?vue&type=style&index=0&id=074e7c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e7c20",
  null
  
)

export default component.exports